/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Has_GarageInputs */

const cs_form_has_garage = /** @type {(inputs: Form_Has_GarageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garáž`)
};

const en_form_has_garage = /** @type {(inputs: Form_Has_GarageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garage`)
};

/**
* | output |
* | --- |
* | "Garage" |
*
* @param {Form_Has_GarageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_has_garage = /** @type {((inputs?: Form_Has_GarageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Has_GarageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_has_garage(inputs)
	return cs_form_has_garage(inputs)
});